import BubbleService from "../BubbleService";

class CustomerService extends BubbleService {
  constructor() {
    super();
  }

  findCustomer = async (cccd:string,email:string) => {
    const data = await this.postWf('find_customer',{cccd,email})
    return data
  }

  login = async (phoneNumber:string, pass:string) => {
    const data = await this.postWf('login',{phoneNumber,pass})
    return data;
  }

  sendServiceTracking = async (service_name:string,user_id:string, phone_number: string) => {
    const data = await this.postWf('send_shinhan_tracking',{service_name,user_id, phone_number})
    return data;
  }

  getServiceTracking = async () => {
    const data:any = await this.getObj('Shinhan_Services_Track')
    return data.results;
  }

  sendBusmapTracking = async (page: string) => {
    return await this.postWf('busmap_tracking', {page})
  }
}

export default CustomerService;
    